"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCookies = void 0;
function parseCookies() {
    return window.document.cookie
        .split(';')
        .map(function (v) { return v.split('='); })
        .reduce(function (acc, _a) {
        var key = _a[0], val = _a[1];
        if (val)
            acc[decodeURIComponent(key.trim())] = decodeURIComponent(val.trim());
        return acc;
    }, {});
}
exports.parseCookies = parseCookies;
